import gql from 'graphql-tag';

export const GET_TECH_EVENTS = gql`
  query GetTechEvents($upcoming: Boolean) {
    countries {
      code
      name
    }
    techEvents(upcoming: $upcoming) {
      id
      name
      location
      city
      country_code
      latitude
      longitude
      start_date
      end_date
      description
      website
      website_active
      google_maps_link
      image_url
    }
  }
`;

export const GET_TECH_EVENT_BY_ID = gql`
  query GetTechEventById($id: ID!) {
    techEvent(id: $id) {
      id
      name
      location
      city
      country_code
      latitude
      longitude
      start_date
      end_date
      description
      website
      website_active
      google_maps_link
      image_url
    }
  }
`;
